import { styled } from "@mui/material";

export const Textarea = styled("textarea")({
  resize: "none",
  borderRadius: "4px",
  border: "1px solid #E8E9EB",
  outline: "none",
  padding: ".3rem .5rem",
  fontSize: "1.4rem",
  fontFamily: "Open Sans",
  color: "#58595B",
  minHeight: "10rem",
});
